import PropTypes from 'prop-types';
import React from 'react';
import { IconButton, Stack, Typography } from '@mui/material';
import { Refresh } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import CustomTooltip from '../../atoms/CustomTooltip';

const RefreshButton = ({
  title,
  dataUpdatedAt,
  refreshAction,
  isRefreshing,
  color,
}) => {
  const { t, i18n } = useTranslation();
  return (
    <CustomTooltip
      title={
        <Stack>
          <Typography variant="body2">{title}</Typography>
          {dataUpdatedAt ? (
            <Typography variant="body2">
              {t('components.main_list.filter.last_updated', {
                updated: new Date(dataUpdatedAt).toLocaleString(i18n.language),
              })}
            </Typography>
          ) : null}
        </Stack>
      }
      placement="right"
    >
      <IconButton color="primary" onClick={refreshAction} size="small">
        <Refresh
          sx={
            isRefreshing
              ? {
                  animation: 'spin 2s linear infinite',
                  '@keyframes spin': {
                    '0%': {
                      transform: 'rotate(360deg)',
                    },
                    '100%': {
                      transform: 'rotate(0deg)',
                    },
                  },
                  color,
                }
              : { color }
          }
        />
      </IconButton>
    </CustomTooltip>
  );
};

RefreshButton.propTypes = {
  dataUpdatedAt: PropTypes.number,
  isRefreshing: PropTypes.bool.isRequired,
  refreshAction: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  color: PropTypes.string,
};

export default RefreshButton;
